<template>
  <div class="dropdown-wrapper" @mouseleave="show = false">
    <div @click="toggleVisibility">
      <slot>
        <v-btn height="32px" min-width="40px" class="tertiary" depressed>
          <v-icon large color="primary">mdi-dots-horizontal</v-icon>
        </v-btn>
      </slot>
    </div>

    <ul class="dropdown" v-show="show">
      <li
        v-for="{ key, text } in formatedOptions"
        :key="`dropdown--option-${key}`"
        :class="`dropdown--option-${key}`"
        class="dropdown--option"
        @click="
          show = false;
          $emit(key);
          $emit('click', key);
        "
      >
        <slot v-bind:text="text" name="item">
          {{ text }}
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>
import { isString } from "@/services/util";

const dropdowns = [];

export default {
  name: "Dropdown",
  props: {
    options: Array,
    default: () => []
  },
  data: () => ({
    show: false
  }),
  created() {
    dropdowns.push(this);
  },
  beforeDestroy() {
    dropdowns.splice(dropdowns.indexOf(this), 1);
  },
  methods: {
    toggleVisibility() {
      const show = this.show;
      dropdowns.forEach(dropdown => (dropdown.show = false));

      this.show = !show;
    }
  },
  computed: {
    formatedOptions() {
      if (!this.options || !this.options.length) return [];
      return this.options.map(option => {
        if (isString(option)) {
          return {
            key: option.toLowerCase(),
            text: option
          };
        } else if (option.key && option.text) {
          return option;
        } else {
          console.error("Illegal option", option);
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.dropdown-wrapper
  position: relative
  display: inline-block
  .dropdown
    position: absolute
    z-index: 1
    list-style: none
    padding: 0
    background-color: white
    border: 1px solid $dark-grey
    &--option
      text-align: left
      min-width: 100px
      padding: .75rem 1rem
      cursor: pointer
      white-space: nowrap
      &:hover
        background-color: $light-grey
</style>
